import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { BASE_URL_Image } from '../../constants';

export default function RMgallery() {
  return (
    <Box sx={{  px: 3,p: 3 }}>
      {/* Section 1 */}
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        🩸 Blood Donation Drive at GERMI 🩸
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        On 20th May 2025, GERMI, in collaboration with Sankalp India Foundation, successfully organized a Blood Donation Drive for the benefit of children with Thalassemia.
      </Typography>
      <Grid container spacing={2} sx={{ mb: 5 }}>
        {itemData.slice(0, 2).map((item, index) => (
          <Grid item xs={12} sm={6} md={6} key={index}>
            <img
              src={BASE_URL_Image+item.img}
              alt={item.title}
              loading="lazy"
              style={{ width: '100%', borderRadius: 8 }}
            />
          </Grid>
        ))}
      </Grid>

      {/* Section 2 */}
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        GERMI Celebrates International Yoga Day on 21 June 2025
      </Typography>
      <Grid container spacing={2} sx={{ mb: 5 }}>
  {itemData.slice(2, 7).map((item, index) => (
    <Grid item xs={12} sm={6} md={4} key={index}>
            <img
              src={BASE_URL_Image+item.img}
              alt={item.title}
              loading="lazy"
              style={{ width: '100%',height:200, borderRadius: 8 }}
            />
          </Grid>
        ))}
      </Grid>

      {/* Section 3 */}
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        World Environment Day 2025 at GERMI's Upcoming Campus in Bhat Industrial Area
      </Typography>
     <Grid container spacing={2}>
        {itemData.slice(7, 12).map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <img
              src={BASE_URL_Image+item.img}
              alt={item.title}
              loading="lazy"
              style={{ width: '100%', borderRadius: 8 }}
            />
          </Grid>
        ))}
      </Grid>

    </Box>
  );
}
const itemData = [
  {
    img: 'Gallery/Events+%26+Celebrations/Blood+Donation/blood+donation+certificate+2025.jpg',
    title: 'Breakfast',
    author: '@bkristastucchio',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Blood+Donation/GERMI+Compiled+Photo.jpg',
    title: 'Burger',
    author: '@rollelflex_graphy726',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Yoga+Day+2025/01.jpg',
    title: 'Camera',
    author: '@helloimnik',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Yoga+Day+2025/02.jpg',
    title: 'Coffee',
    author: '@nolanissac',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Yoga+Day+2025/03.jpg',
    title: 'Hats',
    author: '@hjrc33',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Yoga+Day+2025/04.jpg',
    title: 'Honey',
    author: '@arwinneil',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Yoga+Day+2025/05.jpg',
    title: 'Basketball',
    author: '@tjdragotta',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Environment+Day+2025/05.jpg',
    title: 'Fern',
    author: '@katie_wasserman',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Environment+Day+2025/02.jpg',
    title: 'Mushrooms',
    author: '@silverdalex',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Environment+Day+2025/03.jpg',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Environment+Day+2025/04.jpg',
    title: 'Sea star',
    author: '@peterlaster',
  },
  {
    img: 'Gallery/Events+%26+Celebrations/Environment+Day+2025/01.jpg',
    title: 'Bike',
    author: '@southside_customs',
  },
];